<lib-chat-view
  [messages]="messages() ?? []"
  [showCursor]="showCursor() || agentStore().isRunning()"
  [runError]="runError()"
  (clarificationSubmit)="resumeWithAnswer($event)"
  (errorRetry)="retryLastRun()" />
